import type {
  GETActivityCategoriesLookup,
  GETAdvancementPositionsLookupResponse,
  GETPersonPositionsLookupResponse,
  GETSwimmingClassificationLookup,
  GetActivityCollabOrgResponse,
  GetLookupOptoutReasonsResponse,
} from '@appTypes/esb';
import { tagTypes } from '@modules/rtk/constants';
import { esbApi } from '@modules/rtk/esb-api';

const ONE_DAY = 60 * 60 * 24;

export const lookupsApi = esbApi.injectEndpoints({
  endpoints: builder => ({
    /**
     * @esbEndpoint GET /lookups/registrations/renewalOptoutReasons
     */
    getLookupOptoutReasons: builder.query<GetLookupOptoutReasonsResponse, void>(
      {
        query: () => ({ url: '/lookups/registrations/renewalOptoutReasons' }),
        keepUnusedDataFor: ONE_DAY,
        providesTags: () => [tagTypes.LookupOptoutReasons],
      },
    ),

    /**
     * @esbEndpoint GET /lookups/advancements/positions
     */
    getLookupAdvancementsPositions: builder.query<
      GETAdvancementPositionsLookupResponse,
      void
    >({
      query: () => ({ url: '/lookups/advancements/positions' }),
      keepUnusedDataFor: ONE_DAY,
      providesTags: () => [tagTypes.LookupAdvancementPositions],
    }),

    /**
     * @esbEndpoint GET /lookups/advancements/swimmingClassification
     */
    getLookupSwimmingCalssifications: builder.query<
      GETSwimmingClassificationLookup,
      void
    >({
      query: () => ({ url: '/lookups/advancements/swimmingClassification' }),
      keepUnusedDataFor: ONE_DAY,
      providesTags: () => [tagTypes.LookupSwimmingCalssifications],
    }),

    /**
     * @esbEndpoint GET /lookups/person/positions
     */
    getLookupPersonPositions: builder.query<
      GETPersonPositionsLookupResponse,
      void
    >({
      query: () => ({ url: '/lookups/person/positions' }),
      keepUnusedDataFor: ONE_DAY,
      providesTags: () => [tagTypes.LookupPersonPositions],
    }),

    /**
     * @esbEndpoint GET /lookups/advancements/activityCategories
     */
    lookupActivityCategories: builder.query<GETActivityCategoriesLookup, void>({
      query: () => ({ url: '/lookups/advancements/activityCategories' }),
      providesTags: () => [tagTypes.LookupActivityCategories],
      keepUnusedDataFor: ONE_DAY,
    }),

    /**
     * @esbEndpoint GET /lookups/advancements/activityCollaborativeOrganizations
     */
    getLookupActivityCollabOrgs: builder.query<
      GetActivityCollabOrgResponse,
      void
    >({
      query: () => ({
        url: '/lookups/advancements/activityCollaborativeOrganizations',
      }),
      providesTags: () => [tagTypes.LookupActivityCollabOrgs],
      keepUnusedDataFor: ONE_DAY,
    }),
  }),
});

export const {
  useGetLookupOptoutReasonsQuery,
  useGetLookupAdvancementsPositionsQuery,
  useGetLookupSwimmingCalssificationsQuery,
  useLazyGetLookupOptoutReasonsQuery,
  useGetLookupPersonPositionsQuery,
  useLookupActivityCategoriesQuery,
  useGetLookupActivityCollabOrgsQuery,
} = lookupsApi;
